var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissedCallVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(723 -3284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H15V15H0Z",
    transform: "translate(-723 3284)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-800 2817.743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.122,10A1.191,1.191,0,0,1,0,8.75V1.25A1.191,1.191,0,0,1,1.122,0H10.1a1.191,1.191,0,0,1,1.122,1.25V2.721L13.812.854a.785.785,0,0,1,.46-.146A.683.683,0,0,1,15,1.335v7.33a.682.682,0,0,1-.728.626.782.782,0,0,1-.46-.146L11.218,7.279V8.75A1.191,1.191,0,0,1,10.1,10Z",
    transform: "translate(77 469)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.648.1a.349.349,0,0,0-.495,0L.7,5.553v-3A.362.362,0,0,0,.4,2.2a.351.351,0,0,0-.4.347V6.4a.352.352,0,0,0,.351.35h3.5a.362.362,0,0,0,.358-.3.351.351,0,0,0-.347-.4H1.2L6.648.6a.353.353,0,0,0,0-.5Z",
    transform: "translate(79.458 470.624)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissedCallVideo);
export default __webpack_public_path__ + "static/media/missedCallVideo.8f1d6a72.svg";
export { ForwardRef as ReactComponent };